import {LoadingContext} from "../store/loadingMessageStore";
import {useViewerStore} from "../store/store";
import {
    LoadModelJson,
    LoadModelXML
} from "../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/Loader";
import {logger} from "../services/loggingService";
import { AlertType } from "../@types/enums";
import { NavigateFunction } from "react-router-dom";

export const getSite = async (navigate: NavigateFunction) => {
    const loadingContext = new LoadingContext();
    loadingContext.setMessage({ message: 'Fetching Site Data...' });
    const sceneViewer = useViewerStore.getState().sceneViewer;
    const siteDesigns = useViewerStore.getState().siteDesigns;

    useViewerStore.setState({
        designID: 0,
        siteBuildingData: [],
        isSiteReCentered: false,
        selectedDesignIndex: -1,
        selectedLossesVendor: 'OneDraw',
    });

    try {
        if (siteDesigns.aurora != null) {
            await LoadModelJson(sceneViewer, siteDesigns.aurora);
            useViewerStore.setState({selectedSiteDesign : 'aurora'});
        } else if (siteDesigns.eagleView != null) {
            await LoadModelXML(sceneViewer, siteDesigns.eagleView);
            useViewerStore.setState({selectedSiteDesign : 'eagleView'});
        } else {
            throw new Error("No data found in Aurora or EagleView.");
        }
    } catch (e) {
        logger.error(e);
        sceneViewer.viewerAlert({
            show: true,
            title: "Loading Error",
            message: 
                "Something went wrong while loading the site. Please try again later or refresh the browser.\n"
                + `Error: ${(e as Error).message}`,
            messageType: AlertType.error,
            isModal: true,
        });
    } finally {
        loadingContext.dispose();
    }
};
